<template>
    <awesome-icon-styled class="awesome-icon" @click="clickHandler" :noMargin="noMargin">
        <font-awesome-icon :icon="icon" />
    </awesome-icon-styled>
</template>
<script>
import styled from "vue-styled-components";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faApple, faGooglePlay } from "@fortawesome/free-brands-svg-icons";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";
import {
    faExclamationCircle,
    faTimes,
    faFlag,
    faExclamationTriangle,
    faThumbsUp,
    faBell,
    faSearch,
    faSearchPlus,
    faLink,
    faShareAlt,
    faHeart,
    faMinusCircle,
    faSortDown,
    faSortUp,
    faTimesCircle,
    faHandPaper,
    faSchool,
    faArrowLeft,
    faBook,
    faPhone,
    faEnvelope,
    faAngleDoubleUp,
    faAngleUp
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add([
    faAngleDoubleUp,
    faAngleUp,
    faExclamationCircle,
    faApple,
    faGooglePlay,
    faTimes,
    faFlag,
    faExclamationTriangle,
    faThumbsUp,
    faBell,
    faSearch,
    faSearchPlus,
    faLink,
    faShareAlt,
    farHeart,
    faHeart,
    faMinusCircle,
    faSortDown,
    faSortUp,
    faTimesCircle,
    faHandPaper,
    faSchool,
    faArrowLeft,
    faBook,
    faEnvelope
]);

const props = {
    noMargin: {
        type: Boolean,
        default: () => false
    }
};

const AwesomeIconStyled = styled("div", props)`
    display: inline-flex;
    margin-right: ${props => (props.noMargin ? "0px" : "4px")};
    vertical-align: middle;
`;

export default {
    name: "AwesomeIcon",
    props: {
        ...props,
        name: String,
        preset: {
            type: String,
            default: () => "fas"
        }
    },
    computed: {
        icon() {
            return [this.preset, this.name];
        }
    },
    methods: {
        clickHandler(ev) {
            this.$emit("click", ev);
        }
    },
    components: {
        FontAwesomeIcon,
        AwesomeIconStyled
    }
};
</script>
